import { assertNever } from "@impero-com/common/utils/obj";

import { ColumnDropdown } from "components/columnDropdown";

import { SimpleColumn } from "..";

function ViewAdjuster<ITEM>(props: ViewAdjusterProps<ITEM>) {
    const { columns, displayedColumns } = props;
    const isColumnDisplayed = stateToIsColumnDisplayed<ITEM>(displayedColumns);
    return (
        <ColumnDropdown
            columns={columns
                .filter((col) => col.display !== "NEVER")
                .map((col) => {
                    return {
                        value: {
                            name: col.extractor.id,
                            label: col.extractor.label,
                        },
                        displayed: isColumnDisplayed(col),
                        available: isColumnAvailable(col),
                        onToggle: (checked: boolean) => {
                            const newValue = nonDefaultDisplayedColumn(
                                col,
                                checked
                            );
                            if (newValue !== undefined) {
                                props.addToDisplayedColumns(
                                    col.extractor.id,
                                    checked
                                );
                            } else {
                                props.deleteFromDisplayedColumns(
                                    col.extractor.id
                                );
                            }
                        },
                    };
                })}
        />
    );
}

interface ViewAdjusterProps<ITEM> {
    columns: Array<SimpleColumn<ITEM>>;
    displayedColumns: DisplayedColumns;
    addToDisplayedColumns: (colId: string, displayed: boolean) => void;
    deleteFromDisplayedColumns: (colId: string) => void;
}

interface DisplayedColumns {
    [colId: string]: boolean;
}

function stateToIsColumnDisplayed<ITEM>(state: DisplayedColumns) {
    return (column: SimpleColumn<ITEM>) => {
        switch (column.display) {
            case "ALWAYS": {
                return true;
            }
            case "DEFAULT_VISIBLE": {
                const value = state[column.extractor.id];
                return value !== undefined ? value : true;
            }
            case "DEFAULT_HIDDEN": {
                const value = state[column.extractor.id];
                return value !== undefined ? value : false;
            }
            case "NEVER": {
                return false;
            }
            default:
                return assertNever(column.display);
        }
    };
}

function nonDefaultDisplayedColumn<ITEM>(
    column: SimpleColumn<ITEM>,
    displayed: boolean
): boolean | undefined {
    switch (column.display) {
        case "ALWAYS":
            return undefined;
        case "DEFAULT_VISIBLE":
            return displayed ? undefined : false;
        case "DEFAULT_HIDDEN":
            return displayed ? true : undefined;
        case "NEVER":
            return undefined;
        default:
            return assertNever(column.display);
    }
}

function isColumnAvailable<ITEM>(column: SimpleColumn<ITEM>) {
    return column.display !== "ALWAYS";
}

export { ViewAdjuster, stateToIsColumnDisplayed };
